<!--
 * @Name: menu
 * @Description: 菜单管理
 * @Author: xiadongxue
 * @Date: 2021-10-20 16:15:54
 * @Editors: xiadongxue
-->
<template>
<div
    class="menu-wrap"
    v-loading="loading">
    <div class="header-icon">
        <div
            class="click-icon add_icon"
            @click="toAddMenu(0,0)"></div>
        <div
            class="click-icon refresh_icon"
            @click="refresh"></div>
        <search
            :data="{
                projectList: projectList
            }"
            :isRole="true"
            :searchForm="searchForm"
            :searchData="filter"
            @submit="toSearch" />
    </div>
    <el-table
        :data="list"
        style="width: 100%"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        row-key="menuId"
        class="level-table"
        stripe
        :indent="30"
        border>
        <el-table-column
            v-for="item in tableColumn"
            :key="item.prop"
            align="center"
            :prop="item.prop"
            :label="item.label">
            <template v-slot="{row}">
                <template v-if="item.prop === 'createTime'">
                    {{row[item.prop] ? new Date(row[item.prop]).Format("yyyy-MM-dd") : ''}}
                </template>
                <template v-else>{{row[item.prop]}}</template>
            </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            width="210">
            <template v-slot="{row}">
                <el-button
                    v-if="row.menuRank < 3"
                    type="text"
                    @click="toAddMenu(1,row.menuId)">添加</el-button>
                <el-button
                    type="text"
                    @click="toEditMenu(row)">编辑</el-button>
                <el-button
                    type="text"
                    @click="deleteMenu(row.menuId)">删除</el-button>
                <el-button
                    type="text"
                    @click="toAddMenu(2,row.menuId,row.btnList,row.menuName)">按钮绑定</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog
        v-loading="loading"
        :class="{'menu-dialog': !isBtnLevel,btnDialog: isBtnLevel}"
        title="菜单信息"
        :visible.sync="visible"
        :modal-append-to-body="false"
        @closed="close"
        :width="!isBtnLevel ? '600px' : '1200px'">
        <el-form
            :label-width="!isBtnLevel ? '170px' : '100px'"
            :inline="isBtnLevel"
            ref="form"
            :model="menuData"
            :rules="menuRules">
            <div>
                <el-form-item
                    prop="projectId"
                    label="子系统">
                    <el-select
                        disabled
                        size="small"
                        v-model="filter.projectId">
                        <el-option
                            v-for="item in projectList"
                            :key="item.projectId"
                            :value="item.projectId"
                            :label="item.projectName" />
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="菜单名称"
                    v-if="menuData.level === 2">
                    <el-input
                        disabled
                        v-model="menuData.menuName1"
                        size="small" />
                </el-form-item>
            </div>
            <template v-if="menuData.level !== 2">
                <el-form-item
                    prop="menuName"
                    label="菜单名称">
                    <el-input
                        v-model="menuData.menuName"
                        size="small" />
                </el-form-item>
                <el-form-item
                    prop="url"
                    label="前端地址">
                    <el-input
                        v-model="menuData.url"
                        size="small" />
                </el-form-item>
            </template>
            <template v-else>
                <el-form-item
                    prop="menuName"
                    label="按钮名称">
                    <el-input
                        v-model="menuData.menuName"
                        size="small" />
                </el-form-item>
                <el-form-item
                    prop="businessMenuId"
                    label="按钮Key">
                    <el-input
                        v-model="menuData.businessMenuId"
                        size="small" />
                </el-form-item>
                <el-button
                    size="small"
                    style="margin-top: 5px;margin-left: 10px;"
                    icon="el-icon-plus"
                    @click="addServerUrls">接口</el-button>
                <template v-for="(link,index) in menuData.serverUrls">
                    <el-row
                        class="btn-link"
                        :key="index">
                        <el-form-item :label="index === 0 ? '接口地址' : ' '">
                            <el-input
                                v-model="menuData.serverUrls[index]"
                                size="small" />
                            <i class="el-icon-delete" @click="deleteServerUrls(index)"></i>
                        </el-form-item>
                    </el-row>
                </template>
                <el-row>
                    <el-button
                        size="small"
                        style="float: right;margin-bottom: 10px;margin-right: 15px;"
                        @click="toSubmit">按钮添加</el-button>
                </el-row>
            </template>
        </el-form>
        <el-table
            v-if="isBtnLevel"
            :data="menuData.btnList"
            style="width: 100%"
            stripe
            border>
            <el-table-column
                prop="menuName"
                width="260"
                label="按钮名称"
                align="center">
                <template v-slot="{row}">
                    <template v-if="editMenuId !== row.menuId">
                        {{row.menuName}}
                    </template>
                    <el-input
                        v-else
                        required
                        size="small"
                        v-model="menuName"></el-input>
                </template>
            </el-table-column>
            <el-table-column
                prop="businessMenuId"
                width="150"
                label="按钮Key"
                align="center" />
            <el-table-column
                prop="menuName"
                align="center"
                label="接口地址">
                <template v-slot="{row}">
                    <template v-if="editMenuId !== row.menuId">
                        {{row.serverUrls}}
                    </template>
                    <template v-else>
                        <el-row v-if="!serverUrls.length">
                            <el-button
                                size="small"
                                icon="el-icon-plus"
                                @click="addServerUrls(true)">接口</el-button>
                        </el-row>
                        <el-row
                            class="btn-link"
                            style="margin-bottom: 5px;"
                            :gutter="10"
                            v-for="(url,index) in serverUrls"
                            :key="index">
                            <el-input
                                size="small"
                                v-model="serverUrls[index]" />
                            <i class="el-icon-delete" @click="deleteServerUrls(index,true)"></i>
                            <el-button
                                style="position:absolute;left:0;"
                                v-if="index === 0"
                                size="small"
                                icon="el-icon-plus"
                                @click="addServerUrls(true)">接口</el-button>
                        </el-row>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="150"
                align="center">
                <template v-slot="{row,$index}">
                    <el-button
                        type="text"
                        @click="deleteMenu(row.menuId,$index)">删除</el-button>
                    <el-button
                        v-if="editMenuId !== row.menuId"
                        type="text"
                        @click="editBtn(row)">编辑</el-button>
                    <el-button
                        v-else
                        :disabled="!menuName"
                        type="text"
                        @click="toSave(true,row)">保存</el-button>
                    <el-button
                        v-if="editMenuId === row.menuId"
                        type="text"
                        @click="cancelBtn">取消</el-button>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="close"
                size="small">取消</el-button>
            <el-button
                v-if="isBtnLevel"
                @click="close"
                size="small"
                type="danger">确定</el-button>
            <el-button
                v-else
                size="small"
                @click="toSubmit"
                type="danger">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import Search from '@/components/Search.vue'
import {
    getMenuByProject,
    addMenu,
    editMenu,
    delMenu
} from './api'
import {
    mapGetters
} from 'vuex'
export default {
    name: 'menuList',
    components: {
        Search
    },
    computed: {
        ...mapGetters(['projectList', 'projectId']),
        //是否为按钮层级的
        isBtnLevel() {
            return this.menuData.level === 2
        }
    },
    data() {
        return {
            loading: false,
            //添加&修改弹窗显示
            visible: false,
            //是否为添加菜单
            add: false,
            //编辑的按钮menuId
            editMenuId: 0,
            //添加&修改表单项
            defaultMenuData: {
                parentId: '',
                menuName: '',
                level: 0,
                url: '',
                businessMenuId: '',
                serverUrls: [],
                btnList: []
            },
            menuName: '',
            serverUrls: [],
            menuData: {},
            //筛选配置项
            searchForm: [{
                type: 'select',
                key: 'projectId',
                label: '子系统',
                data: 'projectList',
                value: 'projectId',
                name: 'projectName',
                required: true
            }, {
                type: 'input',
                key: 'businessMenuId',
                label: '按钮Key',
                required: false
            }],
            //筛选默认项
            filter: {
                projectId: '',
                businessMenuId: ''
            },
            //表格数据
            list: [],
            tableColumn: [{
                prop: 'menuName',
                label: '菜单名称'
            }, {
                prop: 'url',
                label: '前端路由'
            }, {
                prop: 'projectName',
                label: '所属项目'
            }, {
                prop: 'createTime',
                label: '创建时间'
            }],
            menuRules: {
                menuName: [{
                    required: true,
                    message: '请输入',
                    trigger: 'change',
                }],
                url: [{
                    required: true,
                    message: '请输入',
                    trigger: 'change',
                }],
                businessMenuId: [{
                    required: true,
                    message: '请输入',
                    trigger: 'change',
                }]
            }
        }
    },
    created() {
        this.$watch('projectList', val => {
            if (val.length) {
                this.filter.projectId = this.projectId
                this.toSearch(this.filter)
            }
        })
        if (this.projectList.length) {
            this.filter.projectId = this.projectId
            this.toSearch(this.filter)
        }
    },
    methods: {
        //点击查询
        async toSearch(filter) {
            try {
                this.loading = true
                this.filter = JSON.parse(JSON.stringify(filter))
                this.defaultMenuData.projectId = this.filter.projectId
                let {
                    code,
                    result
                } = await getMenuByProject(filter)
                if (code === 0) {
                    this.list = result
                }
                this.loading = false
            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        //重置
        refresh() {
            this.toSearch(this.filter)
        },
        //按钮编辑
        editBtn(row) {
            this.editMenuId = row.menuId
            this.menuName = row.menuName
            this.serverUrls = row.serverUrls ? row.serverUrls.split(',') : []
        },
        //取消按钮编辑
        cancelBtn() {
            this.editMenuId = ''
            this.menuName = ''
            this.serverUrls = []
        },
        //删除
        async deleteMenu(menuId, index) {
            try {
                let res = await this.$confirm('确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                if (res) {
                    let {
                        code
                    } = await delMenu({
                        menuId
                    })
                    if (code === 0) {
                        //删除按钮特殊处理
                        if (this.isBtnLevel) {
                            this.menuData.btnList.splice(index, 1)
                        } else {
                            this.$message.success('删除成功')
                            this.toSearch(this.filter)
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        //弹窗关闭
        close() {
            this.visible = false
            if (this.isBtnLevel) {
                this.toSearch(this.filter)
            }
            this.menuData = JSON.parse(JSON.stringify(this.defaultMenuData))
            this.$nextTick(this.$refs['form'].clearValidate)
        },
        //点击确定
        toSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    //通过校验
                    this.toSave()
                } else {
                    return false
                }
            });
        },
        //保存
        async toSave(flag, row) {
            try {
                //添加菜单||修改菜单 && 添加按钮||修改按钮
                this.loading = true
                let Fn = editMenu
                let info = flag === true ? row : this.menuData
                let data = {
                    menuName: flag === true ? this.menuName : info.menuName,
                    level: info.level
                }
                //添加||修改按钮
                if (this.isBtnLevel) {
                    data.businessMenuId = info.businessMenuId
                    let serverUrls = flag === true ? this.serverUrls : info.serverUrls
                    serverUrls = serverUrls.filter(item => item)
                    data.serverUrls = serverUrls.join(',')
                } else {
                    //添加||修改菜单
                    data.url = info.url
                }

                if (this.add && flag !== true) {
                    Fn = addMenu
                    data.projectId = this.filter.projectId
                    data.parentId = info.parentId
                } else {
                    data.menuId = info.menuId
                }

                let {
                    code,
                    result
                } = await Fn(data)
                if (code === 0) {
                    //添加||修改菜单
                    if (!this.isBtnLevel) {
                        this.$message.success(`${this.add ? '添加' : '修改'}成功`)
                        this.toSearch(this.filter)
                        this.close()
                    }

                    //添加按钮
                    if (this.isBtnLevel && flag !== true) {
                        this.$message.success(`添加成功`)
                        this.menuData.btnList.push({
                            businessMenuId: this.menuData.businessMenuId,
                            menuName: this.menuData.menuName,
                            menuId: result,
                            level: 2,
                            serverUrls: data.serverUrls
                        })
                        this.menuData.menuName = ''
                        this.menuData.businessMenuId = ''
                        this.menuData.serverUrls = []
                        this.$nextTick(this.$refs['form'].clearValidate)
                    }

                    //修改按钮
                    if (flag === true) {
                        this.$message.success(`保存成功`)
                        row.menuName = this.menuName
                        row.serverUrls = data.serverUrls
                        this.editMenuId = ''
                        this.menuName = ''
                        this.serverUrls = []
                    }
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },
        //删除接口地址
        deleteServerUrls(index, flag) {
            if (flag === true) {
                this.serverUrls.splice(index, 1)
            } else {
                this.menuData.serverUrls.splice(index, 1)
            }
        },
        //新增接口地址
        addServerUrls(flag) {
            if (flag === true) {
                this.serverUrls.push('')
            } else {
                this.menuData.serverUrls.push('')
            }
        },
        //添加菜单 & 按钮
        toAddMenu(level, parentId, btnList, menuName) {
            let menuData = JSON.parse(JSON.stringify(this.defaultMenuData))
            this.menuData = {
                ...menuData,
                level,
                parentId,
                menuName1: menuName
            }
            if (level === 2) {
                this.menuData.btnList = btnList || []
            }
            this.visible = true
            this.add = true
        },
        //编辑菜单
        toEditMenu(row) {
            this.menuData = Object.assign({},row)
            this.visible = true
            this.add = false
        }
    }
}
</script>

<style lang="scss">
.menu-dialog {

    .el-input,
    .el-select,
    .el-textarea {
        width: 240px;
    }
}

.btnDialog {

    .el-input,
    .el-select,
    .el-textarea {
        width: 170px;
    }

    .el-dialog__body {
        max-height: 400px;
        overflow: auto;
    }
}

.btn-link {
    .el-icon-delete {
        cursor: pointer;
    }

    .el-input {
        margin-right: 10px;
    }
}
</style>
